import React from 'react';
import {
  BodyText,
  Column,
  ProgressBar,
  Row,
  SubscriptionComponentCard,
  Tooltip,
} from '../../../atoms';

import {
  Name,
  Overage,
  Prepaid,
  RowWrapper,
  Usage,
  Used,
} from './PrepaidComponent.styles';
import { PrepaidProps } from './types';
import { defaultTranslations } from './constants';
import { Icon } from '@chargify/icons';

const PrepaidComponent = ({
  name,
  prepaid,
  usage,
  isCumulative,
  unit,
  translations = defaultTranslations,
  description,
  cardVariant = 'primary',
  overageBalance,
  isRenewable,
}: PrepaidProps) => (
  <SubscriptionComponentCard rowGap={0} variant={cardVariant}>
    <RowWrapper marginBottom={3}>
      <Name gridColumnGap={2}>
        <BodyText
          variant="body2"
          color="gray.dark"
          fontWeight={2}
          overflow="truncate"
        >
          {name}
        </BodyText>
        {description && (
          <Tooltip
            renderContent={() => <Tooltip.Text message={description} />}
            placement="top-start"
            followCursor
          >
            <Icon type="questionCircle" size={16} fill="gray.dark" />
          </Tooltip>
        )}
      </Name>
    </RowWrapper>
    <BodyText variant="body3" color="gray.dark" fontWeight={0}>
      {isRenewable && (
        <span>{translations.resources_renew_every_billing_period}</span>
      )}
    </BodyText>
    <BodyText variant="body3" color="gray.dark" fontWeight={0}>
      {isCumulative && (
        <span>
          {
            translations.remaining_resources_will_roll_over_to_next_billing_period
          }
        </span>
      )}
    </BodyText>
    <RowWrapper marginTop={5}>
      <ProgressBar max={prepaid} value={usage} mode="light" />
    </RowWrapper>
    <RowWrapper marginTop={3}>
      <Row>
        <Column span={12}>
          <Prepaid>
            <BodyText variant="body2" color="gray.main" fontWeight={2}>
              {translations.prepaid}
            </BodyText>
            <BodyText variant="body2" color="black.main">
              {prepaid} {unit}
            </BodyText>
          </Prepaid>
        </Column>
        <Column span={12}>
          <Usage>
            {usage > prepaid && (
              <Overage textAlign="right" paddingRight={4}>
                <BodyText
                  variant="body2"
                  color="danger.light"
                  fontWeight={2}
                  textAlign="right"
                >
                  {translations.overages}
                </BodyText>
                <BodyText
                  variant="body2"
                  color="danger.light"
                  textAlign="right"
                >
                  {overageBalance} {unit}
                </BodyText>
              </Overage>
            )}
            <Used textAlign="right" paddingLeft={4}>
              <BodyText
                variant="body2"
                color="gray.main"
                fontWeight={2}
                textAlign="right"
              >
                {translations.usage}
              </BodyText>
              <BodyText variant="body2" color="black.main" textAlign="right">
                {usage} {unit}
              </BodyText>
            </Used>
          </Usage>
        </Column>
      </Row>
    </RowWrapper>
  </SubscriptionComponentCard>
);

export default PrepaidComponent;
